<template>
  <div>
    <navbar
      :userName="partnerDetails.longDesc"
      @userLogout="logOut($event)"
      class="w-100 nav-bar-style"
    />
    <div class="notification-card" v-if="false">
      <!--<b-card v-if="scrollMessages.length > 0" class="card-alert">
        <div class="row card-row">
          <div class="col-sm-1">
            <img :src="require('@/assets/info.png')" alt="info-image" class="img-info" />
          </div>
          <div class="col-sm-9 text-left">
            <span
              class="scroll-message"
              v-if="!readMore"
            >{{scrollMessages[messageIndex].message.slice(0, 100)}}&nbsp;</span>
            <a
              v-if="!readMore && scrollMessages[messageIndex].message.slice(0, 100).length < scrollMessages[messageIndex].message.length"
              @click="readMore=true"
            >
              <span class="read-more-less">Read more...</span>
            </a>
            <span
              class="scroll-message"
              v-if="readMore"
            >{{scrollMessages[messageIndex].message}}&nbsp;</span>
            <a class="read-more-less" v-if="readMore" @click="readMore=false">
              <span class="read-more-less">Read less</span>
            </a>
          </div>
          <div class="col-sm-2 text-right">
            <img
              :src="require('@/assets/baseline-arrow_back.png')"
              alt="arrow-img"
              class="cursor-pointer prev-arrow"
              @click="previousMessage()"
            />&nbsp;
            <img
              :src="require('@/assets/baseline-arrow_back.png')"
              alt="arrow-img"
              class="cursor-pointer next-arrow"
              @click="nextMessage()"
            />&nbsp;
            <b-icon-x-circle-fill class="cursor-pointer" @click="closeMessageCard()"></b-icon-x-circle-fill>
          </div>
        </div>
      </b-card>-->
    </div>
    <div
      class="position-inherit"
      :style="scrollMessages.length == 0?'margin-top: 60px':'margin-top: 0%'"
    >
    <div @click="panelControl()" class="panel-control" :style="panelOpen?'left: 15%;':'left: 3%;'">
    {{panelOpen ? "<": ">"}}
</div>
      <SidebarMenu :menu="menu" :width="panelOpen?'15%':'3%'" :hideToggle="true">        
        <div slot="header" style="margin-top: 10px !important;
        margin-bottom: 2px !important;padding-bottom: 3px;box-shadow: 0px 2px 2px #385867;"
        v-show="panelOpen">
          <div class="avatar-wrapper">
            <img
              class="avatar-img profile-pic"
              v-if="!profilePictureDocId"
              src="@/assets/user.svg"
              alt="Fluid image"
            />
            <img
              class="avatar-img profile-pic"
              v-if="profilePictureDocId"
              :src="getCompanyImageLogo(profilePictureDocId)"
              alt="Fluid image"
            />
            <input
              class="file-upload img-input"
              ref="profileImg"
              v-on:change="getProfileImage()"
              type="file"
              accept="image/*"
            />
          </div>
          <h3 class="partner-heading" :title="partnerDetails.organizationName">{{partnerDetails.organizationName}}</h3>
          <h4 class="sub-heading">{{partnerDetails.partnerNumber}}</h4>
        </div>
      </SidebarMenu> 
      <router-view class="sidenav" :style="panelOpen?'margin-left:17%!important':'margin-left:5%!important'"/>
    </div>
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />

    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>
<script>
import { SidebarMenu } from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import Navbar from "../components/EmpanelmentNavbar";
import { PartnerService } from "../../src/services/partnerService";
const partnerService = new PartnerService();
import { DashboardService } from "../../src/services/DashboardService";
const service = new DashboardService();
import loadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import $ from "jquery";

import { AESService } from "../../src/services/AES.js";
let aesService = new AESService()
export default {
  components: { 
    SidebarMenu,
    navbar: Navbar,
    "w-loadingSpinner": loadingSpinner,
    "w-modal": widgetModal
  },
  data() {
    return {
      panelOpen: true,
      scrollMessages: [],
      alertPresent: true,
      messageIndex: 0,
      loading: false,
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      readMore: false,
      fileTypes: [],
      menu: [
        // {
        //   href: "/partnerStatus",
        //   name: "Project Status",
        //   title: "Project Status",
        //   icon: "fas fa-tachometer-alt",
        //   disabled: false,
        //   attributes: {
        //     hidden: false
        //   }
        // },
        {
          href: "/partnerdashboard",
          name: "Dashboard",
          title: "Dashboard",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "tachometer-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/partnerprofile",
          name: "My Profile",
          title: "My Profile",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "user-circle"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/partnersummary",
          name: "Order Summary",
          title: "Order Summary",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/partnerauctions",
          name: "E-Bids & E-Auctions",
          title: "E-Bids & E-Auctions",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "chart-line"
            }
          },
          // child: [],
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/partnerreminder",
          name: "Alerts & Reminders",
          title: "Alerts & Reminders",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "bell"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        // {
        //   href: "/partneradmin",
        //   name: "Admin",
        //   title: "Admin",
        //   icon: {
        //     element: "font-awesome-icon",
        //     attributes: {
        //       // icon props:
        //       icon: "chart-line"
        //     }
        //   },
        //   disabled: false,
        //   attributes: {
        //     hidden: false
        //   }
        // },
        {
          href: "/partnerinvoice",
          name: "Partner Invoice",
          title: "Partner Invoice",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: true,
          attributes: {
            hidden: true
          }
        },
        {
          href: "/partnerfeedback",
          name: "Partner Feedback",
          title: "Partner Feedback",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/branchdetails",
          name: "Branch Details",
          title: "Branch Details",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/testimonials",
          name: "Testimonials",
          title: "Testimonials",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },{
          href: "/addcompany",
          name: "Add New Company",
          title: "Add New Company",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        },
        {
          href: "/claimrequest",
          name: "ClaimRequest",
          title: "Grievance Request",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              // icon props:
              icon: "file-alt"
            }
          },
          disabled: false,
          attributes: {
            hidden: false
          }
        }
      ],
      partnerDetails: "",
      profilePicture: "",
      profileFile: [],
      profilePictureId: "",
      profilePictureSiteUrl: "",
      profilePictureDocId: "",
      imageTempArray: [],
      image: undefined,
      imageBind: []
    };
  },
  created() {
    // this.getScrollMessages();
    partnerService.getPartnerInfo().then(resp => {
      this.partnerDetails = resp.response;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
      // this.getPartnerTypeDrop();
      /*if (this.partnerDetails.partnerCategory == "B") {
        this.menu[7].disabled = true;
        this.menu[7].attributes.hidden = true;
      }*/ //contingent enable branch addition
    });
    //this.getPartnerClassification();
    this.getProfilePictureId();
    this.getFileTypesTestimonials();
  },
  watch: {
    'panelOpen': function(newVal, oldVal) {
      if(newVal==false) {
         $('.vsm--item').css('pointer-events','none')
         $('.vsm--title').css('display','none')
      } else {
         $('.vsm--item').css('pointer-events','auto')
         $('.vsm--title').css('display','block')
      }
    }
  },
  methods: {
    panelControl(){
      this.panelOpen=!this.panelOpen
    },
    getScrollMessages() {
      var scrollMessageRequest = {
        listMessageTypeId: [],
        loginAuditNumber: null
      };
      scrollMessageRequest.listMessageTypeId.push(3);
      scrollMessageRequest.listMessageTypeId.push(4);
      scrollMessageRequest.loginAuditNumber = sessionStorage.getItem(
        "AuditNumber"
      );
      service
        .getScrollMessages(scrollMessageRequest)
        .then(res => {
          // console.log("Response", res);
          if (res.failureMessage == "") {
            this.scrollMessages = res.response;
          } else {
            this.scrollMessages = [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    previousMessage() {
      this.readMore = false;
      if (this.messageIndex != 0) {
        this.messageIndex -= 1;
      } else {
        this.messageIndex = this.scrollMessages.length - 1;
      }
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.successModal = false;
      this.alertModal = false;
    },
    nextMessage() {
      this.readMore = false;
      if (this.messageIndex != this.scrollMessages.length - 1) {
        this.messageIndex += 1;
      } else {
        this.messageIndex = 0;
      }
    },
    closeMessageCard() {
      this.scrollMessages = [];
    },
    getFileTypesTestimonials() {
      partnerService
        .getFileTypesByModule("PTM")
        .then(res => {
          this.fileTypes = res.response;
          console.log(this.fileTypes);
        })
        .catch(err => {
          console.log(`Error Occured ${err}`);
        });
    },
    getProfileImage() {
      this.profilePicture = this.$refs.profileImg.files[0];
      var fileSplit = this.profilePicture.name.split(".");
      // alert(fileSplit[1]);
      var temp = false;
      for (let i = 0; i < this.fileTypes.length; i++) {
        if (
          this.fileTypes[i].fileType.toLowerCase() == fileSplit[1].toLowerCase()
        ) {
          temp = true;
          break;
        }
      }
      if (temp == true) {
        var reader = new FileReader();
        this.loading = true;
        let data = new FormData();
        console.log(this.profilePicture);

        data.append("file", this.profilePicture);
        partnerService.uploadProfilePicture(data).then(res => {
          console.log(res);
          if (res) {
            this.profilePictureId = res.UniqueID;
            this.profilePictureSiteUrl = res.SiteUrl;
            console.log(this.profilePictureId);
            this.loading = false;
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = "Profile picture uploaded successfully";
            if (this.profilePictureId != "") {
              this.setProfilePictureID(this.profilePictureId,this.profilePictureSiteUrl);
            }
          }
        });

        reader.onload = function(e) {
          $(".profile-pic").attr("src", e.target.result);
        };
        reader.readAsDataURL(this.profilePicture);
        $(".file-upload").on("change", function() {
          readURL(this);
        });
      } else {
        this.loading = false;
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse =
          "Please upload valid file format (" +
          this.fileTypes[0].fileType +
          ", " +
          this.fileTypes[1].fileType +
          ", " +
          this.fileTypes[2].fileType +
          ", " +
          this.fileTypes[3].fileType +
          ", " +
          this.fileTypes[4].fileType +
          ")";
      }
    },
    setProfilePictureID(tempId,siteUrl) {
      partnerService.setProfilePicture(tempId,siteUrl).then(res => {
        console.log(res.response);
      });
    },
    getProfilePictureId() {
      partnerService.getProfilePicture().then(res => {
        this.profilePictureDocId = res.response;
        console.log(res.response);
        this.getProfile();
      });
    },
    getCompanyImageLogo(docId) {
      for (let j = 0; j < this.imageBind.length; j++) {
        if (this.imageBind[j].docId == docId) {
          return this.imageBind[j].image;
        }
      }
    },
    getProfile() {
      let resImage = null;
      let tempImageBind = {
        image: undefined,
        docId: ""
      };
      let docId = this.profilePictureDocId;
      console.log(docId);
      partnerService.downloadProfilePicture(docId).then(res => {
        this.image = res;
        resImage = this.image;
        var uInt8Array = new Uint8Array(resImage);
        var i = uInt8Array.length;
        var biStr = new Array(i);
        while (i--) {
          biStr[i] = String.fromCharCode(uInt8Array[i]);
        }
        var data = biStr.join("");
        var base64 = window.btoa(data);
        // let tempImage = "data:image/jpeg;base64," + base64;
        this.imageTempArray.push("data:image/jpeg;base64," + base64);
        tempImageBind.image = "data:image/jpeg;base64," + base64;
        tempImageBind.docId = docId;
        this.imageBind.push(tempImageBind);
      });
      console.log(this.imageBind);
    },
    logOut() {
      var auditNumber = sessionStorage.getItem("AuditNumber");
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(auditNumber);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      // sessionStorage.clear();
      partnerService
        .userLogout(data)
        .then(res => {
          sessionStorage.clear();
          this.$router.push("/home");
        })
        .catch(err => {
          this.$router.push("/home");
          console.log(err);
        });
    },
    getPartnerClassification() {
      partnerService
        .getPartnerClassification()
        .then(res => {
          if (res.response.classificationCode == 2) {
            this.menu[7].disabled = true;
            this.menu[7].attributes.hidden = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.notification-card {
  margin-top: 80px !important;
}
.card-alert {
  box-shadow: 0px 1px 6px #00000029;
  opacity: 1;
  background-color: #d1ecf1;
  position: inherit;
}
.card-row {
  margin-left: 15%;
  margin-bottom: 0;
  position: inherit;
}
.scroll-message {
  padding: 0 0 0 0;
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.read-more-less {
  color: #0c5e9d;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 200;
}
.prev-arrow {
  transform: matrix(-1, 0, 0, -1, 0, 0);
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
}
.next-arrow {
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
}
.img-info {
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 25px;
}
.nav-bar-style {
  top: 0px;
  position: fixed;
  z-index: 5;
}
.v-sidebar-menu {
  top: 60px;
  margin-bottom: 5%;
  text-align: left;
  background-color: #14436a !important;
  /* height: 100vh !important; */
  font-family: "Source Sans Pro", sans-serif;
  color: #ffffff;
  overflow: visible;
  z-index: 100 !important;
  transition: 0s width;
  font-size: 16px;
  font-weight: 500 !important;
}
.partner-heading {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  color: #ffffff;
  font-weight: bold !important;
  font-size: 18px !important;
  padding: 2px 20px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.sub-heading {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  color: #ffffff;
  font-size: 14px !important;
}
.partner-image {
  display: block;
  margin: 0 auto;
}
.v-sidebar-menu .vsm--link {
  padding: 2.5px;
  cursor: pointer;
  position: relative;
  display: block;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 20;
  -webkit-transition: 0.3s all;
  transition: 0.3s all;
}
.v-sidebar-menu .vsm-item.first-item.active-item > .vsm-link {
  box-shadow: none !important;
  opacity: 1 !important;
  color: #fff !important;
  font-weight: 500 !important;
}
.v-sidebar-menu .vsm-item.first-item.active-item > .vsm-link > .vsm-icon {
  color: #1285ff !important;
}
.v-sidebar-menu .vsm-item.active-item > .vsm-link,
.v-sidebar-menu .vsm-item.parent-active-item > .vsm-link {
  font-weight: 500;
  box-shadow: none !important;
}
.v-sidebar-menu .vsm-item.first-item.active-item {
  font-weight: 500 !important;
}
.sidenav {
  margin-left: 15% !important;
  
  transition: margin-left 300ms;
}
.v-sidebar-menu .vsm--link .vsm--title::after {
  content: url("../assets/sidebar/sidebar_dropdown_arrow.svg");
  transform: rotate(-90deg) !important;
  width: 15px !important;
  margin-right: 5px;
  float: right;
  right: 0 !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  height: 15px;
  width: 20px;
  text-align: center;
  margin-top: 8px;
  margin-left: 2%;
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  box-shadow: 5px 0px 0px 0px #ffffff inset;
  background-color: #ffffff20;
}

.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
  background-color: #ffffff20;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon,
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon {
  background-color: transparent;
}
.avatar-img {
  /* margin-top: 35px; */
  width: 50px;
  height: 50px;
  border-radius: 50% !important;
  /* cursor: pointer; */
  margin-left: auto !important;
  margin-right: auto !important;
  display: block;
}

.avatar-wrapper {
  position: relative;
}
.img-input {
  position: absolute;
  top: 8px;
  left: 23%;
  width: 90px;
  height: 90px;
  border-radius: 50% !important;
  opacity: 0;
  cursor: pointer;
}
.save-button {
  background: #f9a431;
  border: none;
  font-family: Cabin;
  color: #ffffff;
  border-radius: 5px;
  font-size: 18px;
  width: 150px;
  height: 48px;
  margin-top: 41px;
}
.portal-save-button {
  margin-top: 30px;
  background: #f9a431;
  border: none;
  font-family: Cabin;
  color: #ffffff;
  border-radius: 5px;
  font-size: 18px;
  width: 150px;
  height: 48px;
}
.application-title {
  width: 267px;
  margin-top: 39px;
}
.password-title {
  width: 222px;
  margin-top: 39px;
}
.panel-control{
    position: fixed;
    background: #14436a;
    z-index: 100;
    cursor: pointer;
    color: #fff;
    top: 50%;    
    height: 90px;
    padding: 4px;
    font-weight: bold;
    padding-top: 20px;
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;
    box-shadow: 2px 2px 10px #939393;
  transition: 300ms left;
  opacity: 0.9;
    font-family: cursive;
    font-size: 28px;
    background: linear-gradient(90deg, #14436a, #2d618c);
    user-select: none;
}
.panel-control:hover{  
    box-shadow: none;
}
.v-sidebar-menu{  
  transition: 300ms max-width;
}
</style>